import React, { FC, useCallback, useState } from "react";
import { Dialog } from "@xapp/components";

import { IntegrationsCard, IntegrationCardProp } from "./IntegrationsCard";

export const ServiceTitanIntegrationCard: FC<IntegrationCardProp> = ({ appId, disabled, isLinked, isActive, onDisconnect }) => {

    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleServiceTitanClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        // pop up modal
        setShowDialog(true);
    };

    const handleDisconnectServiceTitan = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const actions = [
        {
            label: "Close",
            onClick: () => { setShowDialog(false) }
        }
    ]

    return (
        <>
            <IntegrationsCard
                disabled={disabled}
                imageUrl="/img/integrations/servicetitan/service-titan-logo.png"
                text="ServiceTitan"
                href={() => "/integrations/servicetitan"}
                onClick={handleServiceTitanClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectServiceTitan : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="ServiceTitan"
                onClose={() => { setShowDialog(false) }}
            >
                <p>We will be contacting you to help with the ServiceTitan integration.</p>
            </Dialog>
        </>
    )
}